import { render } from "./LayoutSplit.vue?vue&type=template&id=58ef86da&scoped=true"
import script from "./LayoutSplit.vue?vue&type=script&lang=js"
export * from "./LayoutSplit.vue?vue&type=script&lang=js"

import "./LayoutSplit.vue?vue&type=style&index=0&id=58ef86da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ef86da"]])

export default __exports__